import React from "react";

export default function Header() {
  return (
    <nav className="header-baby-list">
      <h1>Giulia's Baby Register</h1>
    </nav>
  );
}
